import React from 'react'
import { dataAnalyticsTopics } from '../constants/track1'
import { dataManagementTopics } from '../constants/track2'
import { bigDataTopics } from '../constants/track3'
import { computationalIntelligenceTopics } from '../constants/track4'
import { communicationNetworksTopics } from '../constants/track5'

const CallForPapers = () => {
  return (
    <div>
        <h1 className='text-4xl font-semibold text-center m-3'>Call for Papers</h1>
        <hr className="mb-4 border-black border-2 w-96 m-auto"/>
        <p className='text-lg font-medium m-3 text-justify'>The scope of this conference is to provide a platform for researchers, engineers, academicians as well as industrial professionals from all over the world to present their research results and development activities in various topics of Computational Technologies and Data Analytics. It allows participants an opportunity to discuss the recent developments in the field of solidification computer science and review challenges faced by the community in the 21st century. The conference consists of different tracks which are listed below as:</p>
        
        <div className="p-4 border-solid border-2 border-black w-1/2 m-auto">
        <h1 className='text-2xl font-semibold  m-3'>Track 1: Data Analytics</h1>
        <ul className='p-4 '>
        {dataAnalyticsTopics.map((t)=>{
          return <li className='list-disc'>{t}</li>
        })}
        </ul>
        </div>
        <div className="p-4 border-solid border-2 border-black my-4 w-1/2 m-auto">
        <h1 className='text-2xl font-semibold  m-3'>Track 2: Data Management</h1>
        <ul className='p-4'>
        {dataManagementTopics.map((t)=>{
          return <li className='list-disc'>{t}</li>
        })}
        </ul>
        </div>
        <div className="p-4 border-solid border-2 border-black my-4 w-1/2 m-auto">
        <h1 className='text-2xl font-semibold  m-3'>Track 3: Big Data</h1>
        <ul className='p-4'>
        {bigDataTopics.map((t)=>{
          return <li className='list-disc'>{t}</li>
        })}
        </ul>
        </div>
        <div className="p-4 border-solid border-2 border-black my-4 w-1/2 m-auto">
        <h1 className='text-2xl font-semibold  m-3'>Track 4: Computational Intelligence</h1>
        <ul className='p-4'>
        {computationalIntelligenceTopics.map((t)=>{
          return <li className='list-disc'>{t}</li>
        })}
        </ul>
        </div>
        
        <div className="p-4 border-solid border-2 border-black my-4 w-1/2 m-auto">
        <h1 className='text-2xl font-semibold  m-3'>Track 5: Communication Networks</h1>
        <ul className='p-4'>
        {communicationNetworksTopics.map((t)=>{
          return <li className='list-disc'>{t}</li>
        })}
        </ul>
        </div>
        <p className='text-lg font-medium m-3 text-justify'>The papers submitted to the conference will be peer-reviewed and published as SCOPUS indexed proceedings.</p>
        <p className='text-lg font-normal m-3 text-justify'>All the accepted papers of ICCTRDA-2026 will be published as a proceedings of ICCTRDA-2026 in Springer LNNS series indexed by Scopus, Ei, WoS, and other reputed databases. Some papers will be invited to be submitted in Scopus and SCIE indexed Journals.</p>
    </div>
  )
}

export default CallForPapers